'use strict';

angular.module('app').factory('VideoService', VideoService);

VideoService.$inject = ['ApiService'];

function VideoService( ApiService) {
    return {
        getAllVideos: function () {
            return ApiService.get('api/coach/videos').then(function (res) {
                return res;
            }, function (err) {
                return err;
            });
        },
        getVideosForCustomer: function () {
            return ApiService.get('api/devices/videos').then(function (res) {
                return res;
            }, function (err) {
                return err;
            });
        },

        compareVideos: function (a, b) {
            if (parseInt(a.position) < parseInt(b.position))
                return -1;
            if (parseInt(a.position) > parseInt(b.position))
                return 1;
            return 0;
        }
    };
}

